import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export enum FpCorrelationSummaryActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
}

export interface FpCorrelationSummaryActionGetData {
  type: FpCorrelationSummaryActionType.GetData;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
}

export interface FpCorrelationSummaryActionGetDataSuccesses {
  type: FpCorrelationSummaryActionType.GetDataSuccesses;
  date: string | null;
  data: IFpCorrelationData | null;
}

export type FpCorrelationSummaryActions =
  | FpCorrelationSummaryActionGetData
  | FpCorrelationSummaryActionGetDataSuccesses;
